// The signed-in session, shared with every screen. The router's sign-in guard fills it from
// `GET /api/me` on each protected navigation, so a shell can read who is signed in synchronously
// and never has to show a placeholder name.
import { useSyncExternalStore } from "react";
import type { Me } from "../api/types";

let current: Me | null = null;
const listeners = new Set<() => void>();

export function setSession(me: Me | null) {
  current = me;
  for (const l of listeners) l();
}
export function clearSession() { setSession(null); }

function subscribe(l: () => void) { listeners.add(l); return () => { listeners.delete(l); }; }
function snapshot() { return current; }

/** The current session, or null when nobody is signed in (or it has not been fetched yet). */
export function useSession(): Me | null {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
